import { FormType } from '../../../form-types';
import { MigraineQuestionFieldAnswers } from '../questions';
import { migraineCommon } from './common';

export const migraine1stLine: FormType<MigraineQuestionFieldAnswers> = {
  name: 'Acute Migraine 1st Line Questionnaire',
  questions: [
    ...migraineCommon.questions,
    {
      key: 'migraine_nsaidsTried',
      next: {
        condition: { 'migraine_nsaidsTried.not_effective': true },
        key: 'generic_ineligible',
        els: 'migraine_antidepressants'
      }
    },
    {
      key: 'migraine_antidepressants',
      next: {
        condition: { 'migraine_antidepressants.yes': true },
        key: 'migraine_serotoninSyndromeAck',
        els: 'migraine_otherInformation'
      }
    },
    {
      key: 'migraine_serotoninSyndromeAck',
      next: {
        condition: { 'migraine_serotoninSyndromeAck.avoid_class': true },
        key: 'generic_ineligible',
        els: 'migraine_otherInformation'
      }
    },
    'migraine_otherInformation',
    {
      key: 'migraine_treatmentConsent',
      next: {
        condition: { 'migraine_treatmentConsent.do_not_continue': true },
        key: 'generic_didNotConsent',
        els: 'generic_complete'
      }
    },
    'generic_complete',
    'generic_ineligible',
    'generic_didNotConsent'
  ]
};
